import { Button, TableRow, MenuItem, TableCell, Typography, IconButton } from '@mui/material';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
import { useBoolean } from 'src/hooks/use-boolean';
import { BranchType } from 'src/type/branch';

type Props = {
  row: BranchType;
  loading: boolean;
  onEdit: VoidFunction;
  handleDelete: VoidFunction;
};

export default function SettingBranchRow({ row, onEdit, loading, handleDelete }: Props) {
  const popover = usePopover();
  const { name } = row;
  const confirm = useBoolean();

  return (
    <>
      <TableRow>
        <TableCell>
          <Typography variant="body2" noWrap>
            {name}
          </Typography>
        </TableCell>

        <TableCell>
          <IconButton
            color={popover.open ? 'inherit' : 'default'}
            onClick={popover.onOpen}
            disabled={loading}
          >
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="top-right"
        sx={{ width: 160 }}
      >
        <MenuItem
          onClick={() => {
            popover.onClose();
            onEdit();
          }}
        >
          <Iconify icon="solar:pen-bold-duotone" />
          แก้ไข
        </MenuItem>

        <MenuItem
          onClick={() => {
            popover.onClose();
            confirm.onTrue();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          ลบ
        </MenuItem>
      </CustomPopover>

      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="ลบรายการสาขา"
        content={`คุณต้องการลบรายการสาขา ${name} ใช่หรือไม่?`}
        action={
          <Button
            variant="contained"
            color="inherit"
            onClick={() => {
              handleDelete();
              confirm.onFalse();
            }}
          >
            ยืนยันการลบ
          </Button>
        }
      />
    </>
  );
}
